export const isIPv4 = (IP) => {
    const parts = IP.split('.');

    return (
        parts.length === 4 &&
        parts.every( part => {
            const num = Number(part);

            return num >= 0 && num <= 255 && String(num) === part;
        })
    );
}

export const isIPv6 = (IP) => {
    const ipv6Regex = /^(([a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|([a-fA-F0-9]{1,4}:){1,7}:|:([a-fA-F0-9]{1,4}:){1,7}|([a-fA-F0-9]{1,4}:){1,6}:[a-fA-F0-9]{1,4}|([a-fA-F0-9]{1,4}:){1,5}(:[a-fA-F0-9]{1,4}){1,2}|([a-fA-F0-9]{1,4}:){1,4}(:[a-fA-F0-9]{1,4}){1,3}|([a-fA-F0-9]{1,4}:){1,3}(:[a-fA-F0-9]{1,4}){1,4}|([a-fA-F0-9]{1,4}:){1,2}(:[a-fA-F0-9]{1,4}){1,5}|[a-fA-F0-9]{1,4}:(:[a-fA-F0-9]{1,4}){1,6}|::([a-fA-F0-9]{1,4}:){0,6}[a-fA-F0-9]{1,4}|([a-fA-F0-9]{1,4}:){0,7}::)$/;

    return ipv6Regex.test(IP);
}

export const isIP = (IP, onlyIPv4 = false, onlyIPv6 = false) => {
    if (onlyIPv4) {
        return isIPv4(IP);
    }

    if (onlyIPv6) {
        return isIPv6(IP);
    }

    return isIPv4(IP) || isIPv6(IP);
}

export const isEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    return emailRegex.test(email);
}

export const isDomain = (domain) => {
    const domainRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/\S*)?$/;

    return domainRegex.test(domain);
}

export const getValidations = (str) => ({ domain: isDomain(str), email: isEmail(str), ip: isIP(str) })


export default { isIPv4, isIPv6, isIP, isEmail, isDomain, getValidations }
